var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEtikaBisnisIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8752 16.6667V22.5M12.8752 16.6667L19.8752 22.5M12.8752 16.6667L5.87516 22.5M8.2085 6.16667V12M12.8752 8.5V12M17.5418 10.8333V12M24.5418 1.5H1.2085M2.37516 1.5H23.3752V11.0667C23.3752 13.0269 23.3752 14.0069 22.9937 14.7556C22.6581 15.4142 22.1227 15.9496 21.4641 16.2852C20.7154 16.6667 19.7353 16.6667 17.7752 16.6667H7.97516C6.01498 16.6667 5.03489 16.6667 4.2862 16.2852C3.62763 15.9496 3.0922 15.4142 2.75664 14.7556C2.37516 14.0069 2.37516 13.0268 2.37516 11.0667V1.5Z",
    stroke: "#4771FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtikaBisnisIc);
export default __webpack_public_path__ + "static/media/etika-bisnis-ic.725fa901548ed7e0b8679ee94dd598c6.svg";
export { ForwardRef as ReactComponent };